import { EEntityType, EDealType } from '../../types/filters';

export const DEAL_TYPE_BUTTONS = [
  { label: 'Неважно', value: null },
  { label: 'Аренда', value: EDealType.Rent },
  { label: 'Продажа', value: EDealType.Sale },
];

export const FAVORITE_ENTITY_TYPE_BUTTONS = [
  { label: 'Неважно', value: null },
  { label: 'Жилая', value: EEntityType.Residential },
  { label: 'Загородная', value: EEntityType.Suburban },
  { label: 'Коммерческая', value: EEntityType.Commercial },
];
